import React, { useEffect } from "react";
import { useNavigate, useOutletContext, useParams } from "react-router-dom";

import { UnifiedDataTable } from "../../../layout/unified-data-table/ui/unified-data-table";
import type {
  UnifiedDataTableColumnRenderers,
  UnifiedTableRow,
} from "../../../shared/ui/data-table/model/data-table-contract";
import { ROUTES } from "../../../system/router/routes";
import { flowsheetsRecord } from "../model/flowsheets";

import * as Styled from "./flowsheets.styled";

interface IPatientInfoOutletContext {
  setIsStretchContent: React.Dispatch<React.SetStateAction<boolean>>;
}

export const Flowsheets = () => {
  const navigate = useNavigate();
  const { patientID } = useParams();
  const outletContext = useOutletContext<
    IPatientInfoOutletContext | undefined
  >();
  const setIsStretchContent = outletContext?.setIsStretchContent;
  const contentScrollerRef = React.useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    setIsStretchContent?.(true);

    return () => {
      setIsStretchContent?.(false);
    };
  }, [setIsStretchContent]);

  const columnRenderers = React.useMemo<UnifiedDataTableColumnRenderers>(
    () => ({
      flowsheetIdWithAction: ({ value }) => (
        <Styled.FlowsheetIdCell>
          <Styled.RowIcon>
            <i className="pi pi-arrow-right" aria-hidden="true" />
          </Styled.RowIcon>
          <span>{String(value ?? "")}</span>
        </Styled.FlowsheetIdCell>
      ),
      spacer: () => null,
    }),
    [],
  );

  const handleRowClick = React.useCallback(
    (row: UnifiedTableRow) => {
      if (!patientID || typeof row.id !== "string") {
        return;
      }

      navigate(
        ROUTES.PATIENT_DETAILS_FLOWSHEET_DETAILS.replace(
          ":patientID",
          patientID,
        ).replace(":flowsheetID", row.id),
      );
    },
    [navigate, patientID],
  );

  return (
    <Styled.Container>
      <Styled.Title>Flowsheets</Styled.Title>
      <Styled.ContentScroller ref={contentScrollerRef}>
        <UnifiedDataTable
          record={flowsheetsRecord}
          columnRenderers={columnRenderers}
          onRowClick={handleRowClick}
          useSharedSectionNav
          scrollContainerRef={contentScrollerRef}
        />
      </Styled.ContentScroller>
    </Styled.Container>
  );
};
